var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.baseClass, _vm.typeClass, {
        'btn--pending': _vm.pending || _vm.isPending,
        'btn--disabled': _vm.disabled || _vm.isDisabled,
        'btn--toggled': _vm.isToggled,
        'no-animate': _vm.noAnimate,
        [_vm.className]: _vm.className.length
    }],attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){_vm.allowAction ? _vm.handleClick($event) : null}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.content))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }